import { Logger } from "utils/logger";
import type { LoggerConfig } from "utils/logger";

export const useLogger = (context?: string, config?: Partial<LoggerConfig>) => {
  const logger = new Logger(context, config);

  return {
    logger,
    debug: logger.debug.bind(logger),
    info: logger.info.bind(logger),
    warn: logger.warn.bind(logger),
    error: logger.error.bind(logger),
  };
};
